<template>
  <div
    class="rating text-warning"
    itemprop="starRating"
    itemscope
    itemtype="https://schema.org/Rating"
  >
    <span>{{ starText }}</span>
    <sup v-if="superior">S</sup>
    <meta itemprop="ratingValue" :content="stars.toString()" />
  </div>
</template>

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    stars?: number
    superior?: boolean
  }>(),
  {
    stars: 0,
    superior: false,
  },
)

/* Old code:
computed: {
 starText(): string {
   return '★'.repeat(this.stars)
 },
}
*/
const starText = computed(() => '★'.repeat(props.stars))
</script>
